import React, { useEffect, useState } from 'react'
import { Header } from '../../components/Header/Header'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const InterviewHistory = () => {
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }

  // interview history of logged in interviewer
  const role = localStorage.getItem('role')
  const token = localStorage.getItem('token')
  const id = localStorage.getItem('id')
  const [data, setData] = useState([])

  // to keep nav link highlighted when  on same route
  useEffect(() => {
    if (role === 'Interviewer') {
      var nav_item = document.getElementById('historynav')
      nav_item.classList.add('navlinkactive')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // fetch all interviews
  const getData = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'dashboard/fetchCompletedInterviews',
        {
          id: id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        setData(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // columns to display data in table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Name',
      cell: (row) => {
        return (
          <Tippy content={row.candidate_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
            >
              {' '}
              {row.candidate_name}
            </p>
          </Tippy>
        )
      },
      sortable: true,
    },

    {
      name: 'Designation',
      cell: (row) => {
        return (
          <Tippy content={row.designation} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
            >
              {' '}
              {row.designation}
            </p>
          </Tippy>
        )
      },
      sortable: true,
    },

    {
      name: 'HR Status',
      selector: (row) => row.status_hr,
      sortable: true,
      width: '110px',
    },
    {
      name: 'Interview Round',
      selector: (row) => row.interview_round,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Interview Date',
      selector: (row) => moment(row.interview_date).format('DD-MM-YYYY'),
      sortable: true,
      width: '130px',
    },
    {
      name: 'Interview Time',
      selector: (row) => row.interview_time,
      sortable: true,
      width: '130px',
    },
    {
      name: 'Interview Feedback',
      cell: (row) => {
        return (
          <Tippy content={row.interview_feedback} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
            >
              {row.interview_feedback}
            </p>
          </Tippy>
        )
      },
      sortable: true,
    },
    {
      name: 'Next Round?',
      cell: (row) => {
        if (row.eligible_for_next_round === 0) {
          return <p className="mt-3">No</p>
        } else if (row.eligible_for_next_round === 1) {
          return <p className="mt-3">Yes</p>
        } else if (row.eligible_for_next_round === null) {
          return <p className="mt-3">NA</p>
        }
      },
      sortable: true,
    },
  ]
  return (
    <>
      {role === 'HR' || role === 'Admin' ? <Sidebar /> : <Header />}

      <div className="container mt-5 interviewHistory">
        <div className=" mt-2">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link
                  to={
                    role === 'HR' || role === 'Admin'
                      ? '/home'
                      : '/interviewerDashboard'
                  }
                  className="link text-primary"
                >
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                History
              </li>
            </ol>
          </nav>
        </div>
        <DataTable
          title="Past Interviews"
          columns={columns}
          data={data}
          pagination
          highlightOnHover
        />
      </div>
    </>
  )
}
